import { EProvince } from '@if/core/types'
import { COVERED_PROVINCE_CIRCLEK } from '../../types'
import { B2C_MERCHANT_IDS } from '../../types/constants'

export const useMerchantIdFromSubdomain = (): string => {
  const hostname = window.location.hostname
  const subdomain = hostname.split('.')[0]

  if (subdomain in B2C_MERCHANT_IDS) {
    return B2C_MERCHANT_IDS[subdomain as keyof typeof B2C_MERCHANT_IDS]
  }
  if (import.meta.env.DEV) {
    return B2C_MERCHANT_IDS[import.meta.env.VITE_LOCAL_B2C_MERCHANT as keyof typeof B2C_MERCHANT_IDS]
  }

  throw new Error('Merchant ID not found for subdomain: ' + subdomain)
}

export const useIsUncoveredProvince = (province: EProvince | string | undefined): boolean => {
  const merchantId = useMerchantIdFromSubdomain()

  if (!province) return false

  const getCoveredProvinces = () => {
    switch (merchantId) {
      case B2C_MERCHANT_IDS.circlek:
        return COVERED_PROVINCE_CIRCLEK
      case B2C_MERCHANT_IDS.neo:
        return new Set<EProvince>(Object.values(EProvince))
      default:
        return new Set<EProvince>(Object.values(EProvince))
    }
  }

  const coveredProvinces = getCoveredProvinces()
  return !coveredProvinces.has(province as EProvince)
}
